/**
 * Field paths and labels for the "Intermediation with CCSS and ACD" settings, kept out
 * of the component file so it exports nothing but the component (react-refresh).
 */

export const INTERMEDIATION_ENABLED_FIELD = [
  'billingSettings',
  'isCcssAcdIntermediationEnabled',
];

export const INTERMEDIATION_PRICE_FIELD = [
  'billingSettings',
  'ccssAcdIntermediationPrice',
];

export const INTERMEDIATION_LABEL = 'Intermediation with CCSS and ACD';

export const INTERMEDIATION_PRICE_LABEL = 'Intermediation price';

export const INTERMEDIATION_TOOLTIP =
  'When enabled, every monthly billing draft gets a Payroll line for the intermediation fee below.';
